import React from 'react'
import UserBlogs from '../Components/UserBlogs'

function User() {
  return (
    <div>
        <UserBlogs />
    </div>
  )
}

export default User